export default {
  integrations: [],
  discoveredDevices: [],
  queryLocationResponse: null
};